module.exports = {"step_1":"1 - Vehicle selection","step_2":"2 - Other details","continue":{"1":"Continue","2":"Claim your offer"}}